<i18n>
{
    "en_US": {
        "search": "Search"
    },
    "fr_FR": {
        "search": "Rechercher"
    }
}
</i18n>

<template>
    <form v-on:submit.prevent="applySearchTerms">
        <div class="form-group">
            <button class="btn btn-primary add" type="button" v-on:click="createNewNote">
                <i class="fa fa-plus"></i>
            </button>
            <div class="input-group">
                <input type="text" class="form-control search" v-bind:placeholder="$t('search')" v-on:keyup.enter.prevent="applySearchTerms" />
                <span class="input-group-btn">
                    <button class="btn" type="button" v-on:click="applySearchTerms">
                        <i class="fa fa-search"></i>
                    </button>
                </span>
            </div>
        </div>
    </form>
</template>

<script>
    import { mapState, mapActions } from "vuex";

    export default {
        name: "SearchBar",
        computed: {
            ...mapState("search", ["search"])
        },
        watch: {
            search: function(newValue) {
                $(this.$el).find(".search").val(newValue);
                this.applySearchTerms();
            }
        },
        methods: {
            createNewNote: function() {
                this.createNote({
                    title: "_(no title)_"
                })
                    .then(function() {
                        this.$Progress.finish();
                    }.bind(this))
                    .catch(function() {});
            },
            applySearchTerms: function() {
                const value = $(this.$el).find("input").val();
                // We reload
                this.reloadNotes(value)
                    .then(function() {
                        this.$Progress.finish();
                    }.bind(this))
                    .catch(function() {});
            },
            ...mapActions("note", ["createNote", "reloadNotes"])
        }
    }
</script>

<style scoped>
    form, form .form-group {
        margin-bottom: 0;
    }
    form .form-group {
        border-bottom: 1px solid #e4eaec;
        border-top: 0;
        height: 56px;
        display: -webkit-flex;
        display: flex;
    }
    form .form-group > .btn {
        padding: 10px 25px;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        background-image: none;
        vertical-align: top;
        transition: border .2s linear,color .2s linear,width .2s linear,background-color .2s linear;
        -webkit-font-smoothing: subpixel-antialiased;
        border-radius: .143rem;
        font-size: 12px;
        margin-bottom: 0;
        border-radius: 0;
    }
    form .form-group > .input-group {
        flex-grow: 1;
    }
    form .search {
        height: 54px;
        border: 0;
        padding: 10px;
        color: #76838f;
        font-size: 14px;
        font-weight: 100 !important;
        font-family: 'Roboto', sans-serif;
        line-height: 1.571429;
        background: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }
    form .search::-webkit-input-placeholder {
        font-size: 14px !important;
    }
    form .search:-moz-placeholder { /* Firefox 18- */
        font-size: 14px !important;
        line-height: 32px;
    }
    form .search::-moz-placeholder {  /* Firefox 19+ */
        font-size: 14px !important;
        line-height: 32px;
    }
    form .search:focus,
    form .search:active {
        outline: none !important;
        -webkit-appearance: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
    }
    form .input-group .btn {
        padding: 17px 15px;
        margin-bottom: 0;
        color: #76838f;
        background: none;
    }
</style>